// Статус последнего появления контакта в Луни. Ровно 4 значения, считаем по
// МЕСТНОМУ времени юзера (device Date), а не контакта — как в требованиях.
export type LastSeenStatus = "today" | "yesterday" | "recently" | "long-ago"

const MS_PER_DAY = 86_400_000
const RECENT_WINDOW_DAYS = 15

/**
 * Правила (от last_seen_at, в МЕСТНОМ времени зрителя):
 * - "today"     — контакт был в Луни в течение текущих суток
 * - "yesterday" — в течение предыдущих суток
 * - "recently"  — раньше начала предыдущих суток, но не более 15 дней назад
 * - "long-ago"  — более 15 дней назад
 *
 * Без метки времени — null (статус неизвестен / invisible, ничего не рисуем).
 * Онлайн-кейс — забота вызывающего <LastSeen>: у онлайн-контакта подпись не
 * нужна, «в сети» уже передаёт зелёный индикатор на аватаре.
 */
export function getLastSeenStatus(
	lastSeenAt: string | null | undefined,
	now: Date = new Date(),
): LastSeenStatus | null {
	if (!lastSeenAt) return null

	const seen = new Date(lastSeenAt).getTime()
	if (Number.isNaN(seen)) return null

	const startOfToday = new Date(now)
	startOfToday.setHours(0, 0, 0, 0)
	const startOfTodayMs = startOfToday.getTime()

	if (seen >= startOfTodayMs) return "today"
	if (seen >= startOfTodayMs - MS_PER_DAY) return "yesterday"
	if (seen >= now.getTime() - RECENT_WINDOW_DAYS * MS_PER_DAY) return "recently"
	return "long-ago"
}
